import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Row, Col, Card } from "react-bootstrap";
import IconChevronRight from "../../../images/icons/chevron-right-solid.svg";

const CheckoutAddress: React.FC<IProps> = ({
  shippingAddress,
  handleShow,
  showAddAndCloseSelect,
  loading,
}: IProps) => {
  return (
    <S.Wrapper defaultActiveKey="0">
      <S.CheckoutAddressCard>
        <S.CheckoutAddressCardHeader>
          <S.CheckoutAddressCardHeaderTitle eventKey="0">
            Step1 : Select Shipping Address
          </S.CheckoutAddressCardHeaderTitle>
        </S.CheckoutAddressCardHeader>
        <S.CheckoutAddressCardCollapse eventKey="0">
          <S.CheckoutAddressCardBody>
            <Container>
              <Row>
                <Col style={{ padding: 0 }}>
                  {shippingAddress ? (
                    <div>
                      {/* 등록된 shipping 주소 있을 때 */}
                      <S.CheckoutAddressButtonGroup onClick={handleShow}>
                        <S.CheckoutAddressAddressCard className="col-10">
                          <Card.Body>
                            <S.CheckoutAddressPWithoutMarginNickname>
                              {shippingAddress.addressNickname == ""
                                ? "Set address nickname"
                                : shippingAddress.addressNickname}
                            </S.CheckoutAddressPWithoutMarginNickname>
                            <S.CheckoutAddressPWithoutMargin>
                              {shippingAddress.firstName}{" "}
                              {shippingAddress.lastName}
                            </S.CheckoutAddressPWithoutMargin>
                            <S.CheckoutAddressPWithoutMargin>
                              {shippingAddress.streetAddress1}
                              <br />
                              {shippingAddress.postalCode}
                              <br />
                              {shippingAddress.phone}
                            </S.CheckoutAddressPWithoutMargin>
                          </Card.Body>
                        </S.CheckoutAddressAddressCard>
                        <S.CheckoutAddressAddressSelectButton
                          className="col-2"
                          disabled={loading}
                        >
                          <img src={IconChevronRight} width={16} />
                        </S.CheckoutAddressAddressSelectButton>
                      </S.CheckoutAddressButtonGroup>
                    </div>
                  ) : (
                    <div style={{ textAlign: "center" }}>
                      {/* 등록된 shipping 주소 없을 때 */}
                      <S.CheckoutAddressAddAddressButton
                        className="btn btn-outline-primary"
                        onClick={showAddAndCloseSelect}
                      >
                        + Add Shipping Address
                      </S.CheckoutAddressAddAddressButton>
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          </S.CheckoutAddressCardBody>
        </S.CheckoutAddressCardCollapse>
      </S.CheckoutAddressCard>
    </S.Wrapper>
  );
};

export { CheckoutAddress };
